import React, { useRef, useState, useContext, useEffect } from "react";
import Space from "antd/es/space";
import { Input, Select, BaseButton } from "@/components";
import { updateAdvert, getAdvert } from "@/server/advertConfig";
import { TipsContext } from "@/context/Tips";
import "./index.less";

export default function ManagerAccount() {
  const [bannerImgUrl, setBannerImgUrl] = useState("");
  const [bannerJumpUrl, setBannerJumpUrl] = useState("");
  const caseExpandImgUrlList = useRef(["", "", "", ""]);
  const [caseIndex, setCaseIndex] = useState(0);
  const [caseImgUrlList, setCaseImgUrlList] = useState(["", "", "", ""]);
  const { useMessage } = useContext(TipsContext);

  useEffect(() => {
    getAdvert().then((res) => {
      const data = JSON.parse(res.data);
      if (data.bannerImgUrl) {
        setBannerImgUrl(data.bannerImgUrl);
      }
      if (data.bannerJumpUrl) {
        setBannerJumpUrl(data.bannerJumpUrl);
      }
      if (data.caseImgUrlList) {
        setCaseImgUrlList(data.caseImgUrlList);
      }
    });
  }, []);

  return (
    <div className="advert-config-wrap items-center justify-center">
      <Space direction="vertical" size={28}>
        <div className="box">
          <Space direction="vertical" size={33}>
            <h1>顶部轮播图设置</h1>
            <Space size={22} direction="vertical">
              <Input
                defaultValue={bannerImgUrl}
                labelContent="顶部轮播图链接"
                onChange={(v) => {
                  setBannerImgUrl(v);
                }}
              />
              <Input
                defaultValue={bannerJumpUrl}
                labelContent="轮播图跳转链接"
                onChange={(v) => {
                  setBannerJumpUrl(v);
                }}
              />
            </Space>
          </Space>
        </div>
        <div className="box">
          <Space direction="vertical">
            <h1>展开案例设置</h1>
            <Space size={22} direction="vertical" align="start">
              <Select
                chooseList={["第一帧", "第二帧", "第三帧", "第四帧"]}
                onClick={(v) => {
                  setCaseIndex(v);
                }}
              ></Select>
              <Input
                defaultValue={caseImgUrlList[caseIndex]}
                labelContent="案例按钮图链接"
                onChange={(v) => {
                  const list = [...caseImgUrlList];
                  list[caseIndex] = v;
                  setCaseImgUrlList(list);
                }}
              />
            </Space>
          </Space>
        </div>
        <BaseButton
          content="保存"
          type="blue"
          onClick={() => {
            if (
              bannerImgUrl === "" &&
              bannerJumpUrl === "" &&
              caseImgUrlList.includes("")
            ) {
              useMessage.error("保存失败");
            } else {
              updateAdvert({
                bannerImgUrl,
                bannerJumpUrl,
                caseImgUrlList,
              }).then(
                () => {
                  useMessage.success("保存成功");
                },
                () => {
                  useMessage.error("保存失败");
                }
              );
            }
          }}
        />
      </Space>
    </div>
  );
}
